import { h } from 'vue'
import AccountIcon from '@/components/icons/AccountIcon.vue'
import ArrowDownIcon from '@/components/icons/ArrowDownIcon.vue'
import CheckmarkIcon from '@/components/icons/CheckmarkIcon.vue'
import CircleArrowRightIcon from '@/components/icons/CircleArrowRightIcon.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import EmailIcon from '@/components/icons/EmailIcon.vue'
import LaunchIcon from '@/components/icons/LaunchIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import OpenEmailIcon from '@/components/icons/OpenEmailIcon.vue'
import WarningIcon from '@/components/icons/WarningIcon.vue'

const customSvgNameToComponent = {
  AccountIcon,
  ArrowDownIcon,
  CheckmarkIcon,
  CircleArrowRightIcon,
  CloseIcon,
  EmailIcon,
  LaunchIcon,
  LogoutIcon,
  OpenEmailIcon,
  WarningIcon,
}

const customSVGs = {
  component: (props) => h(customSvgNameToComponent[props.icon]),
}

export { customSVGs /* aliases */ }
